import { IconButton, Stack, TableCell, TableRow, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { confirm } from "lib/@dialogs/confirm"
import { alert } from "lib/@dialogs/alert"
import { invalidate } from "lib/graphql/cache"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { getFentraUsers } from "routes/qa/fentra/controllers/get-fentra-users"
import { updateFentraGroup, deleteFentraGroup } from "routes/qa/fentra/controllers/fentra-mutations"
import { FentraGroupDialog } from "routes/qa/fentra/groups/fentra-group-dialog"

export function FentraGroupRow({ group }) {
    const { target } = useBoundContext()
    const profileId = target?._id
    const users = getFentraUsers.useResults({ profileId }) ?? []
    const openGroupDialog = useDialog(<FentraGroupDialog />, { maxWidth: "sm", fullWidth: true })

    return (
        <TableRow hover>
            <TableCell>{group?.displayName}</TableCell>
            <TableCell>{group?.memberExternalIds?.length ?? 0}</TableCell>
            <TableCell align="right">
                <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                    <Tooltip title="Edit">
                        <IconButton size="small" onClick={handleEdit}>
                            <Iconify icon="mdi:pencil" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <IconButton size="small" onClick={handleDelete} color="error">
                            <Iconify icon="mdi:delete" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </TableCell>
        </TableRow>
    )

    async function handleEdit() {
        const data = await openGroupDialog({ mode: "edit", group, users, profileId })
        if (!data) return
        const result = await updateFentraGroup({ id: group._id, ...data })
        if (!result?.ok) {
            const msg = result?.scimStatus
                ? `Update failed (SCIM ${result.scimStatus}): ${result.error}`
                : `Update failed: ${result?.error ?? "Unknown error"}`
            await alert(msg, "Update Group")
            return
        }
        invalidate("fentraGroups")
        successSnackbar("Group updated")
    }

    async function handleDelete() {
        if (!group) return
        if (!(await confirm(`Delete group "${group.displayName}"?`, "Delete Group"))) return
        try {
            await deleteFentraGroup({ id: group._id })
            invalidate("fentraGroups")
            successSnackbar("Group deleted")
        } catch (err) {
            errorSnackbar(err?.message || "Delete failed")
        }
    }
}
